import {
  EnableUserProfile,
  OnClickAction,
  OnPostClick
} from "api/dtos/responses/AdvanceSettingResponse";

export class AppSettingWidget {
  static Tiktok = {
    LimitVideos: 50,
    DefaultItemGetmore: 6,
    NumberPerRow: 4,
    LoadmoreBackground: "#FF0B53",
    ItemBackground: "#fafafa",
    ItemColor: "#000000",
    Title: "My TikTok Feed",
    Caption: "",
    LabelReadmore: "Load more",
    LabelView: "View more",
    ButtonColor: "#FF0B53",
    ItemGetMore: 10,
    AdvanceSetting: {
      headerElement: {
        profilePicture: true,
        postsCount: true,
        username: true,
        followersCount: true,
        followButton: true,
        followButtonBackground: "#FF0B53",
        followingCount: true
      },
      popupSetting: {
        onPostClick: OnPostClick.OpenDetailPopup,
        enableUserProfile: EnableUserProfile.OpenProfileInNewTab
      },
      productTagSetting: {
        onClickAction: OnClickAction.RedirectToShopifyStore,
        ctaButtonText: "Buy now"
      },
      feedContentSetting: {
        roundedCorner: 0,
        postSpacing: 0
      }
    }
  };
  static Instagram = {
    LimitVideos: 50,
    DefaultItemGetmore: 6,
    NumberPerRow: 4,
    LoadmoreBackground:
      "linear-gradient(90.43deg, #1877F2 -127.39%, #CE00F2 -41.29%, #FF5656 86.62%, #FF6C00 210.4%)",
    LabelLoadmore: "View more",
    LabelReadmore: "Load more",
    Title: "Follow us on Instagram",
    ItemBackground: "#000000",
    ItemColor: "#fafafa",
    ButtonColor: "#4E5ECA",
    ItemGetMore: 10,
    ShowProfile: true,
    AdvanceSetting: {
      headerElement: {
        profilePicture: true,
        postsCount: true,
        username: true,
        followersCount: true,
        followButton: true,
        followButtonBackground: "#4E5ECA",
        followingCount: true
      },
      popupSetting: {
        onPostClick: OnPostClick.OpenDetailPopup,
        enableUserProfile: EnableUserProfile.OpenProfileInNewTab
      },
      productTagSetting: {
        onClickAction: OnClickAction.RedirectToShopifyStore,
        ctaButtonText: "Buy now"
      },
      feedContentSetting: {
        roundedCorner: 0,
        postSpacing: 0
      }
    }
  };
}
